<nav class="product-purchases">
  <ul>
    <li *ngFor="let item of items">
      <a
        [routerLink]="[item.path]"
        [ngClass]="{ active: router.url === item.fullPath }"
        >{{ item.header }}</a
      >
      <span *ngIf="item != lastItem">|</span>
    </li>
  </ul>
</nav>
<router-outlet></router-outlet>
